export default "__VITE_ASSET__D5QD19wT__"